import * as React from 'react';
import { SVGProps } from 'react';

const SvgOznamy = (props: SVGProps<SVGSVGElement>) => (
  <svg width={24} height={24} viewBox="0 0 24 24" fill="none" role="img" {...props}>
    <path
      d="M2 .5h20A1.5 1.5 0 0 1 23.5 2v7a1.5 1.5 0 0 1-1.5 1.5H2A1.5 1.5 0 0 1 .5 9V2A1.5 1.5 0 0 1 2 .5Z"
      stroke="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.75 3.55a.65.65 0 0 1 .65-.65h5.2a.65.65 0 1 1 0 1.3H4.4a.65.65 0 0 1-.65-.65ZM3.75 6.45a.65.65 0 0 1 .65-.65h10.2a.65.65 0 1 1 0 1.3H4.4a.65.65 0 0 1-.65-.65Z"
      fill="currentColor"
    />
    <path
      d="M2 13.5h20a1.5 1.5 0 0 1 1.5 1.5v7a1.5 1.5 0 0 1-1.5 1.5H2A1.5 1.5 0 0 1 .5 22v-7A1.5 1.5 0 0 1 2 13.5Z"
      stroke="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.75 16.55a.65.65 0 0 1 .65-.65h5.2a.65.65 0 1 1 0 1.3H4.4a.65.65 0 0 1-.65-.65ZM3.75 19.45a.65.65 0 0 1 .65-.65h10.2a.65.65 0 1 1 0 1.3H4.4a.65.65 0 0 1-.65-.65Z"
      fill="currentColor"
    />
  </svg>
);

export default SvgOznamy;
